import React from 'react';
import './folios.css';

const PdfViewer = () => {
  // Función para verificar si el dispositivo es móvil
  const isMobile = () => {
    return window.matchMedia("only screen and (max-width: 768px)").matches;
  };

  return (
    <div className="pdf-viewer-container">
      <h1 className="pdf-viewer-title">Beneficiarios del Programa Desarrollo Inclusivo</h1>
      {/* Verificar si el dispositivo es móvil */}
      {isMobile() ? (
        // Si es un dispositivo móvil, mostrar el PDF directamente con una altura máxima
        <div className="pdf-viewer-wrapper">
          <object
            data={"https://sebiso.hidalgo.gob.mx/Transparencia/pdfs/RCs/RC_BDI_2024.pdf"}
            type="application/pdf"
            className="pdf-viewer-iframe"
            style={{ width: '450px', height: '600px' }} // Establecer una altura máxima de 500px
          >
            <p>Tu navegador no puede mostrar el PDF. <a href="https://sebiso.hidalgo.gob.mx/Transparencia/pdfs/RCs/RC_BDI_2024.pdf">Descargar PDF</a> en su lugar.</p>
          </object>
        </div>
      ) : (
        // Si no es un dispositivo móvil, mostrar el visor de PDF en un iframe
        <div className="pdf-viewer-wrapper">
          <iframe
            src={"https://sebiso.hidalgo.gob.mx/Transparencia/pdfs/RCs/RC_BDI_2024.pdf"}
            title="Visor de PDF"
            className="pdf-viewer-iframe"
          ></iframe>
        </div>
      )}
    </div>
  );
};

export default PdfViewer;